// Weather
export const GET_CURRENT_WEATHER_BY_ZIP = "GET_CURRENT_WEATHER_BY_ZIP";
export const GET_CURRENT_WEATHER_BY_CITY = "GET_CURRENT_WEATHER_BY_CITY";
export const CLEAR_WEATHER = "CLEAR_WEATHER";
export const GET_FORECAST_BY_ZIP = "GET_FORECAST_BY_ZIP";
export const GET_FORECAST_BY_CITY = "GET_FORECAST_BY_CITY";

// Error
export const CLEAR_ERROR = "CLEAR_ERROR";
export const SET_ERROR = "SET_ERROR";